export class EntProcessingCompaniesFilter {
    page: number;
    size: number;
    deleted: boolean;
    storageName?: string;
    regionId?: number;
    areaId?: number;
    territorialUnitId?: number;
    productType?: number;
	companyName: any;
	legalFormId: any;
	industryTypeId: any;
	address: any;
	registrationDate: any;
	statusId: any;
  
    constructor(init?: Partial<EntProcessingCompaniesFilter>) {
      this.page = 1;
      this.size = 30;
      this.deleted = false;
      if (init) {
        Object.assign(this, init)
      }
    }
  }
    